import { useEffect } from "react";
import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  ADD_TAGS: ["script", "noscript", "iframe"],
  ADD_ATTR: ["async", "defer", "type", "src", "id", "data-id", "data-domain", "crossorigin", "referrerpolicy", "integrity", "frameborder", "allowfullscreen"],
  FORCE_BODY: true,
  WHOLE_DOCUMENT: false,
};

/**
 * Injects sanitized HTML/scripts (e.g., GA4, GTM noscript, Facebook Pixel,
 * Hotjar) supplied via the admin SEO panel into the document body. Script
 * tags are re-created so they actually execute. DOMPurify strips inline
 * event handlers as a defense-in-depth measure even though this field is
 * admin-only.
 */
export default function FooterScripts({ html }) {
  useEffect(() => {
    const MARKER = "data-sauderton-footer-inject";
    document.body.querySelectorAll(`[${MARKER}]`).forEach((n) => n.remove());
    if (!html || !html.trim()) return;

    const safeHtml = DOMPurify.sanitize(html, SANITIZE_CONFIG);
    const wrapper = document.createElement("div");
    wrapper.innerHTML = safeHtml;
    Array.from(wrapper.childNodes).forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.tagName === "SCRIPT") {
        const s = document.createElement("script");
        for (const a of node.attributes) s.setAttribute(a.name, a.value);
        s.text = node.textContent || "";
        s.setAttribute(MARKER, "1");
        document.body.appendChild(s);
      } else {
        node.setAttribute(MARKER, "1");
        document.body.appendChild(node);
      }
    });
  }, [html]);
  return null;
}
